module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title1",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBREVIATIONS USED IN FOOTNOTES")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("Bib")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("BKW")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Bible Key Words from Gerhard Kittel’s Theologisches Wörterbuch zum Neuen Testament")]), _vm._v(" (J. R. Coates, "), _c('em', [_vm._v("et al.")]), _vm._v(", eds.). New York: Harper & Row, 1951–1960. 3 vols.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("CBQ")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("EQ")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("Eschatologie")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_vm._v("H. D. Wendland, "), _c('em', [_vm._v("Die Eschatologie des Reiches Gottes bei Jesus")]), _vm._v(". Gütersloh: Bertelsmann, 1931.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("ET")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("HDB")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("A Dictionary of the Bible")]), _vm._v(" (James Hastings, ed.). New York: Scribners, 1908. 5 vols.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("HTR")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("IB")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("The Interpreter’s Bible")]), _vm._v(" (George Arthur Buttrick, "), _c('em', [_vm._v("et al.")]), _vm._v(", eds.). Nashville: Abingdon Press, 1952–57. 12 vols.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("IDB")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("The Interpreter’s Dictionary of the Bible")]), _vm._v(" (George Arthur Buttrick, "), _c('em', [_vm._v("et al.")]), _vm._v(", eds.). Nashville: Abingdon, 1962. 4 vols.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("Int")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("ISBE")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("The International Standard Bible Encyclopaedia")]), _vm._v(" (James Orr, "), _c('em', [_vm._v("et al.")]), _vm._v(", eds.). Chicago: Howard-Severance, 1930. 5 vols.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("JBL")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("JBR")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Journal of Bible and Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("Judaism")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_vm._v("George Foot Moore, "), _c('em', [_vm._v("Judaism in the First Centuries of the Christian Era")]), _vm._v(". Cambridge: Harvard University, 1927. 3 vols.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("JR")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Journal of Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("Kommentar")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_vm._v("Herman L. Strack and Paul Billerbeck, "), _c('em', [_vm._v("Kommentar zum Neuen Testament aus Talmud und Midrasch")]), _vm._v(". München: Beck, 1922–28. 5 vols.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("Mission")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Reginald H. Fuller, "), _c('em', [_vm._v("The Mission and Achievement of Jesus")]), _vm._v(". ("), _c('em', [_vm._v("Studies in Biblical Theology")]), _vm._v(", XII.) Naperville: Allenson, 1954.")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("NTS")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("RGG")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Die Religion in Geschichte und Gegenwart")]), _vm._v(" (Kurt Galling, ed.; 3rd ed.). Tübingen: Mohr, 1957–61. 5 vols.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("SJTh")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Scottish Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("StTh")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Studia Theologica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("ThTo")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Theology Today")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("TLZ")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Theologische Literaturzeitung")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("TWBB")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("A Theological Word Book of the Bible")]), _vm._v(" (Alan Richardson, ed.). London: S.C.M.; 1950. New York: Macmillan, 1962.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("TZ")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Theologische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("TWNT")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Theologisches Wörterbuch zum Neuen Testament")]), _vm._v(" (Gerhard Kittel, "), _c('em', [_vm._v("et al.")]), _vm._v(", eds.). Stuttgart: Kohlhammer, 1933–1964. 6 vols. to date.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("ZNTW")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("ZSysTh")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Zeitschrift für systematische Theologie")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "abbre"
  }, [_c('span', {
    staticClass: "abb"
  }, [_c('em', [_vm._v("ZTK")])])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "abbre1"
  }, [_c('em', [_vm._v("Zeitschrift für Theologie und Kirche")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8be1212","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Abbreviations.vue
// module id = 72
// module chunks = 0